(function() {
  'use strict';

  var busy = false;
  var checkTimer = null;

  function readConfig() {
    var wrapper = document.getElementById('gift-selector-wrapper');
    if (!wrapper) return null;
    var prop = wrapper.getAttribute('data-gift-prop') || '_gift';
    var idsStr = wrapper.getAttribute('data-qualifying-ids') || '';
    var qualifyingIds = idsStr.split(',').filter(function(id) { return id.length > 0; });

    var variantIds = [];
    var cards = wrapper.querySelectorAll('.gift-product-card[data-variant-id]');
    cards.forEach(function(card) {
      variantIds.push(String(card.getAttribute('data-variant-id')));
    });

    return {
      prop: prop,
      qualifyingIds: qualifyingIds,
      variantIds: variantIds
    };
  }

  function hasQualifyingProduct(cart, cfg) {
    return cart.items.some(function(item) {
      var isGift = item.properties && item.properties[cfg.prop] === 'true';
      if (isGift) return false;
      return cfg.qualifyingIds.indexOf(String(item.product_id)) !== -1;
    });
  }

  function findGiftInCart(cart, cfg) {
    return cart.items.find(function(item) {
      return item.properties &&
             item.properties[cfg.prop] === 'true' &&
             cfg.variantIds.indexOf(String(item.variant_id)) !== -1;
    });
  }

  function updateUI(cart, cfg) {
    var wrapper = document.getElementById('gift-selector-wrapper');
    var trigger = document.getElementById('gift-selector-trigger');
    var notice = document.getElementById('gift-selected-notice');
    if (!wrapper || !trigger || !notice) return;

    var qualified = hasQualifyingProduct(cart, cfg);
    var hasGift = !!findGiftInCart(cart, cfg);

    wrapper.style.display = qualified ? 'block' : 'none';

    if (qualified) {
      trigger.style.display = hasGift ? 'none' : 'block';
      notice.style.display = hasGift ? 'block' : 'none';
    }

    if (!qualified && hasGift) {
      removeGift(cart, cfg);
    }
  }

  function selectGift(variantId, btnElement) {
    if (busy) return;
    busy = true;

    if (btnElement) {
      btnElement.classList.add('loading');
      btnElement.textContent = 'Adicionando...';
    }

    var cfg = readConfig();
    if (!cfg) {
      busy = false;
      resetBtn(btnElement);
      return;
    }

    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var existingGift = findGiftInCart(cart, cfg);

        if (existingGift && String(existingGift.variant_id) === String(variantId)) {
          closeModal();
          return Promise.resolve('skip');
        }

        var removePromise = Promise.resolve();
        if (existingGift) {
          removePromise = fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: existingGift.key, quantity: 0 })
          });
        }

        return removePromise.then(function() {
          var props = {};
          props[cfg.prop] = 'true';
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{ id: parseInt(variantId), quantity: 1, properties: props }]
            })
          });
        }).then(function() {
          closeModal();
          return refreshDrawer();
        }).then(function() {
          setTimeout(checkOnce, 500);
        });
      })
      .catch(function(e) {
        console.error('[GiftSelector] Erro:', e);
      })
      .finally(function() {
        busy = false;
        resetBtn(btnElement);
      });
  }

  function removeGift(cart, cfg) {
    if (busy) return;
    var gift = findGiftInCart(cart, cfg);
    if (!gift) return;

    busy = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: gift.key, quantity: 0 })
    })
    .then(function() { return refreshDrawer(); })
    .then(function() { setTimeout(checkOnce, 500); })
    .catch(function(e) { console.error('[GiftSelector] remove:', e); })
    .finally(function() { busy = false; });
  }

  function resetBtn(btn) {
    if (btn) {
      btn.classList.remove('loading');
      btn.textContent = 'Adicionar';
    }
  }

  function openModal() {
    var overlay = document.getElementById('gift-modal-overlay');
    if (overlay) {
      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeModal() {
    var overlay = document.getElementById('gift-modal-overlay');
    if (overlay) {
      overlay.classList.remove('active');
      document.body.style.overflow = '';
    }
  }

  function refreshDrawer() {
    var sid = getSectionId();
    return fetch('/?sections=' + sid)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var html = data[sid];
        if (!html) return;
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newD = doc.querySelector('[data-section-id="' + sid + '"]') || doc.querySelector('#mini-cart');
        var curD = document.querySelector('[data-section-id="' + sid + '"]') || document.querySelector('#mini-cart');
        if (newD && curD) {
          curD.innerHTML = newD.innerHTML;
        }
      })
      .catch(function(e) { console.error('[GiftSelector] refresh:', e); });
  }

  function getSectionId() {
    var el = document.querySelector('#mini-cart[data-section-id]');
    return (el && el.dataset.sectionId) ? el.dataset.sectionId : 'mini-cart';
  }

  function checkOnce() {
    if (busy) return;
    var cfg = readConfig();
    if (!cfg) return;

    fetch('/cart.js', { cache: 'no-store' })
      .then(function(r) { return r.json(); })
      .then(function(cart) { updateUI(cart, cfg); })
      .catch(function(e) { console.error('[GiftSelector]', e); });
  }

  function scheduleCheck() {
    clearTimeout(checkTimer);
    checkTimer = setTimeout(checkOnce, 500);
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeModal();
  });

  setInterval(function() {
    if (busy) return;
    var wrapper = document.getElementById('gift-selector-wrapper');
    if (!wrapper) return;
    var drawer = document.querySelector('#mini-cart');
    if (!drawer) return;
    var isVisible = drawer.offsetParent !== null || drawer.classList.contains('is-open') || getComputedStyle(drawer).display !== 'none';
    if (isVisible) checkOnce();
  }, 3000);

  document.addEventListener('cart:updated', function() { scheduleCheck(); });
  document.addEventListener('cart:refresh', function() { scheduleCheck(); });
  document.addEventListener('page:loaded', function() { scheduleCheck(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkOnce);
  } else {
    checkOnce();
  }

  window.GiftSelector = {
    openModal: openModal,
    closeModal: closeModal,
    selectGift: selectGift,
    check: checkOnce
  };
})();